import { InputVariantType } from '../variants';
import { buildInputContactCenterStyles } from './contactCenter';
import { buildInputDefaultStyles } from './default';
import { buildInputInputDropdownStyles } from './inputDropdown';
import { buildInputInputPhoneStyles } from './inputPhone';
import { buildInputMainSectionStyles } from './mainSection';
import { buildInputRegularStyles } from './regular';
export const getInputStyles = (FOUNDATIONS, FONT) => {
    return {
        [InputVariantType.DEFAULT]: buildInputDefaultStyles(FOUNDATIONS, FONT),
        [InputVariantType.REGULAR]: buildInputRegularStyles(FOUNDATIONS, FONT),
        [InputVariantType.MAIN_SECTION]: buildInputMainSectionStyles(FOUNDATIONS, FONT),
        [InputVariantType.CONTACT_CENTER]: buildInputContactCenterStyles(FOUNDATIONS, FONT),
        [InputVariantType.INPUT_PHONE]: buildInputInputPhoneStyles(FOUNDATIONS, FONT),
        [InputVariantType.INPUT_DROPDOWN]: buildInputInputDropdownStyles(FOUNDATIONS, FONT),
    };
};
//# sourceMappingURL=index.js.map